import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import useSiteEffects from './lib/useSiteEffects';
import Home from './pages/Home';
import Services from './pages/Services';
import Products from './pages/Products';
import Team from './pages/Team';
import Salon from './pages/Salon';
import Contact from './pages/Contact';
import Calendar from './pages/Calendar';
import BoothInquiry from './pages/BoothInquiry';
import Journal from './pages/Journal';
import Article from './pages/Article';

function App() {
  useSiteEffects();

  return (
    <div className="App" id="site-content">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/products" element={<Products />} />
        <Route path="/team" element={<Team />} />
        <Route path="/salon" element={<Salon />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/booths" element={<BoothInquiry />} />
        <Route path="/booth-inquiry" element={<BoothInquiry />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/journal/:slug" element={<Article />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
